<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">备件档案</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建备件</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        v-model="searchData.Keyword"
        clearable
        placeholder="请输入备件信息编号或名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button
          type="warning"
          @click="handleExport"
          style="margin-left: 10px"
          icon="el-icon-download"
      >下载模板</el-button
      >
      <Upload
          :text="'导入数据'"
          style="margin-left: 10px"
          ref="Upload"
          :uploadUrl="
          $rootUrl +
          '/PB/PB_Material/ImportMaterialToDataBase'
        "
          @success="handleSearch"
      ></Upload>
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column label="" width="50" type="selection">
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
        <el-table-column label="备件编号" align="center" prop="Code" sortable>
        </el-table-column>
        <el-table-column label="备件名称" align="center" prop="Name" sortable>
        </el-table-column>
        <el-table-column
          label="备件类型"
          align="center"
          prop="MaterialTypeName"
          sortable
        >
        </el-table-column>
        <el-table-column label="备件规格" align="center" prop="Spec" sortable>
        </el-table-column>
        <el-table-column
          label="单位"
          align="center"
          prop="storageName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="厂家"
          align="center"
          prop="Manufacturer"
          sortable
        >
        </el-table-column>

        <!-- <el-table-column label="货区类型" align="center" prop="Type">
          <template slot-scope="scope">
            <SelectDicName :typeValue="scope.row.Type" code="StorAreaType" />
          </template>
        </el-table-column> -->

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import tools from '@/utils/tools.js'
import EditForm from './EditForm'
import { mapState } from 'vuex'
import Upload from '@/components/Upload/Upload.vue'
export default {
  data() {
    return {
      searchData: {
        Keyword: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm, Upload },
  methods: {
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/PB/PB_Material/QueryDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: {
            ...this.searchData,
            MaterialTypeId: this.FittingsTreeSearch || '',
          },
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleExport() {
      tools.download(
          this.$rootUrl + '/PB/PB_Material/ExportAccessoryToExcel',
          '备件模板',
          '.xlsx',
          'get'
      )
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建备件信息')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该备件信息, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http.post('/PB/PB_Material/DeleteData', ids).then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('删除成功')
              this.getDataList()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑备件信息', row)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['FittingsTreeSearch']),
  },
  watch: {
    FittingsTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
